/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailFramingOptions_item = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_item">;
    readonly " $refType": "PdpSharedDetailFramingOptions_item";
};
export type PdpSharedDetailFramingOptions_item$data = PdpSharedDetailFramingOptions_item;
export type PdpSharedDetailFramingOptions_item$key = {
    readonly " $data"?: PdpSharedDetailFramingOptions_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailFramingOptions_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailFramingOptions_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item",
      "args": null
    }
  ]
};
(node as any).hash = '49d0f6230269b3ea24a96b9d382155b5';
export default node;
